import { xenn } from './index';

export default {
  list(params) {
    return xenn.get('/lookups', { params: params });
  },
};
